export const DELETE_IMAGE_SUCCESS = 'DELETE_IMAGE_SUCCESS'
export const DELETE_IMAGE_FAILURE = 'DELETE_IMAGE_FAILURE'

export const INDEX_TO_ES_SUCCESS = 'INDEX_TO_ES_SUCCESS'
export const INDEX_TO_ES_FAILURE = 'INDEX_TO_ES_FAILURE'

export const SET_ADMIN_LOADING = 'SET_ADMIN_LOADING'
export const SET_ADMIN_RESULT = 'SET_ADMIN_RESULT'
